module.exports = __webpack_public_path__ + "img/confetti--2.537644e7.svg";